import React, { Component, useContext, useState } from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import StarekContext from "../context/StarekContext";
import { useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";

const MonoLayout = (props) => {
    const starekContext = useContext(StarekContext);
    const location = useLocation();
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        starekContext?.setSnackbarNotification(null);
    };

    return (
        <div className="wrapper">
            <Stack spacing={2} sx={{ width: "100%" }}>
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={starekContext?.snackbarNotification != null}
                    autoHideDuration={5000}
                    onClose={handleClose}
                >
                    {starekContext?.snackbarNotification && (
                        <Alert
                            onClose={handleClose}
                            severity={starekContext.snackbarNotification?.type}
                            sx={{
                                width: "100%",
                                backgroundColor:
                                    starekContext.snackbarNotification?.type ===
                                    "info"
                                        ? "var(--bs-info)"
                                        : starekContext.snackbarNotification
                                                ?.type === "warning"
                                          ? "var(--bs-warning)"
                                          : starekContext.snackbarNotification
                                                  ?.type === "error"
                                            ? "var(--bs-danger)"
                                            : starekContext.snackbarNotification
                                                    ?.type === "success"
                                              ? "var(--bs-success)"
                                              : undefined,
                                fontWeight: 700,
                                "& .MuiAlert-message": {
                                    color:
                                        starekContext.snackbarNotification
                                            ?.type === "warning"
                                            ? "var(--bs-dark)"
                                            : "#fff !important",
                                },
                            }}
                        >
                            {starekContext.snackbarNotification?.text}
                        </Alert>
                    )}
                </Snackbar>
            </Stack>
            <CSSTransition
                key={location.pathname}
                in={true}
                timeout={300}
                classNames="page-crossfade"
            >
                <div>{props.children}</div>
            </CSSTransition>
        </div>
    );
};

export default MonoLayout;
